import { documentsService } from "../../api/documentsService/documentsService";
import { IsAuthorized } from "../../utils/helpers/auth";

export const getDocumentsData = async () => {
    if (IsAuthorized()) {
        const documentsRes = await documentsService.getDocuments();    

        if (documentsRes.success) {
            return {
                documentsApi: documentsRes.responseBody,
            }
        } else {
            console.log('error');
        }
    } else {
        return {
            documentsApi: []
        }
    }    
}